var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPsb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6701 0L13.3301 13.33H26.6701V40L40.0001 26.7V0H26.6701Z",
    fill: "#EA5616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.33 40L26.67 26.67H13.33V0L0 13.3V40H13.33Z",
    fill: "#2C2D84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsb);
export default __webpack_public_path__ + "static/media/psb.e4534e4074efacbf4a0752a88adbe3d6.svg";
export { ForwardRef as ReactComponent };